import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CreateSignatureDialogComponent } from '@lib/components/signature/create-signature-dialog/create-signature-dialog.component';
import { DerViewerPanelService } from '@lib/services/der-viewer-panel.service';
import { OuiDocumentViewer } from 'omnium-ui/document-viewer';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { filter } from 'rxjs';
import { derStepComponent } from '../der-step.component';

@Component({
  selector: 'app-der-viewer-page',
  imports: [SHARED_IMPORTS, OuiDocumentViewer],
  templateUrl: './der-viewer-page.component.html',
  styleUrl: './der-viewer-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DERViewerPageComponent extends derStepComponent implements OnInit {
  private readonly viewerPanelService = inject(DerViewerPanelService);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly showSendToSignature = this.viewerPanelService.showSendToSignature.asReadonly();

  override async ngOnInit(): Promise<void> {
    this.viewerPanelService.openRequestSubject
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe(async () => await this.fetchDER());
  }

  public override sendToSignature(): void {
    const dialogRef = this.dialogService.openDialog(CreateSignatureDialogComponent, { documents: [this.unsignedDocument()] });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.investisseurService.getInvestisseur(this.investisseurService.investisseurSig()?.code as string);
        this.closeSlidePanel();
      }
    });
  }

  closeSlidePanel() {
    this.viewerPanelService.closeDocumentViewer();
  }
}
